import { computed, observable } from 'mobx';

export enum AvatarColour {
  Green = '#32a032',
  Orange = '#ff7f32',
  Red = '#ff3232',
  Purple = '#7832b4',
  Pink = '#c832c8',
  Blue = '#3232c8',
  Black = '#141414',
  Grey1 = '#404040',
  Grey2 = '#7f7f7f'
}

export enum SubscriptionStatus {
  Active = 'active',
  Cancelled = 'canceled',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired'
}

export class User {
  @observable public email: string;
  @observable public firstName?: string;
  @observable public lastName?: string;
  @observable public colour?: AvatarColour;
  @observable public premium?: SubscriptionStatus;
  @observable public premiumEndsAt?: Date;

  constructor(
    email: string,
    firstName?: string,
    lastName?: string,
    colour?: AvatarColour,
    premium?: SubscriptionStatus,
    premiumEndsAt?: Date
  ) {
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.colour = colour;
    this.premium = premium;
    this.premiumEndsAt = premiumEndsAt;
  }

  @computed
  public get isPremium(): boolean {
    const { premium } = this;

    switch (premium) {
      case SubscriptionStatus.Active:
      case SubscriptionStatus.Trialing:
        return true;

      default:
        return false;
    }
  }

  @computed get isActiveCancelledPremium(): boolean {
    const { isPremium, premiumEndsAt } = this;

    return !!(isPremium && premiumEndsAt);
  }

  @computed
  public get isPaidPremium(): boolean {
    const { premium } = this;

    switch (premium) {
      case SubscriptionStatus.Active:
        return true;

      default:
        return false;
    }
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/app/models/User.ts